import { render, staticRenderFns } from "./BotonLinkMenu.vue?vue&type=template&id=1daf2da8&scoped=true&"
import script from "./BotonLinkMenu.vue?vue&type=script&lang=ts&"
export * from "./BotonLinkMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BotonLinkMenu.vue?vue&type=style&index=0&id=1daf2da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf2da8",
  null
  
)

export default component.exports